export default __webpack_public_path__ + "static/media/smartswitches.2e951726.png";